import { ADD_TO_TRANSLATION } from './types';
export const addToTranslation = (translation) => {
  return {
    type: ADD_TO_TRANSLATION,
    translation: translation
  };

};
